import styled from "styled-components";
import { blackColor, greenColor, whiteColor } from "../../../constants/colors";

const PopupBlock = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(9, 1, 16, 0.4);
  z-index: 2;
  opacity: 1;
  transition: opacity 0.25s;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: unset;
`;

PopupBlock.Window = styled.div`
  background: ${whiteColor};
  box-shadow: 0 4px 40px rgb(9 1 16 / 25%);
  border-radius: 16px;
  margin: 20px;
  padding: 20px 20px 20px 20px;
  width: 100%;
  max-width: 500px;
`;

PopupBlock.Title = styled.div`
  margin-bottom: 46px;
  h3 {
    color: ${blackColor};
  }
`;
PopupBlock.Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
PopupBlock.Button = styled.div`
  width: 48%;
  height: 52px;
  background: ${(props) => (props.active ? greenColor : "#f2ede9")};
  border-radius: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s;
  p {
    color: ${(props) => (props.active ? whiteColor : "#000000")};
  }
`;

export { PopupBlock };
